import { useQuery as s } from "@tanstack/vue-query";
import { computed as t, toValue as o } from "vue";
const u = ["ad-group"], n = {
  all: u,
  byCampaign: (a) => [...u, "campaign", a],
  list: (a) => [...n.byCampaign(a), "list"],
  detail: (a, r) => [...n.byCampaign(a), "detail", r]
}, i = (a, r, e) => {
  const p = t(() => n.list(o(r).campaignId));
  return s({
    ...e,
    queryKey: p,
    queryFn: async () => {
      const d = o(r);
      return a.adGroup.findAll({ campaignId: d.campaignId });
    }
  });
}, m = (a, r, e) => {
  const p = t(() => {
    const d = o(r);
    return n.detail(d.campaignId, d.adGroupId);
  });
  return s({
    ...e,
    queryKey: p,
    queryFn: async () => {
      const d = o(r);
      return a.adGroup.findOne({ adGroupId: d.adGroupId });
    }
  });
}, G = async (a, r, e) => {
  await a.prefetchQuery({
    queryKey: n.list(e.campaignId),
    queryFn: async () => r.adGroup.findAll(e)
  });
}, l = async (a, r, e) => {
  await a.prefetchQuery({
    queryKey: n.detail(e.campaignId, e.adGroupId),
    queryFn: async () => r.adGroup.findOne({ adGroupId: e.adGroupId })
  });
};
export {
  n as adGroupKeys,
  l as prefetchAdGroup,
  G as prefetchAdGroups,
  m as useAdGroup,
  i as useAdGroups
};
//# sourceMappingURL=queries.js.map
